import Squads from "./Components/Squads";

export default Squads;
